<template>
    <div class="c-adr col-xl-8 col-lg-8 col-md-8">
        <CCard :extra-style="cardStyle">
            <div :style="eyebrowStyle">Amount mismatch</div>
            <h2 :style="titleStyle">
                Why does the amount you entered differ from the amount indicated on the SOW?
            </h2>
            <p :style="leadStyle">
                Pick whatever fits best — this just flags the deal for review.
            </p>

            <div :style="reasonGridStyle">
                <label
                    v-for="(reason, index) in reasons"
                    :key="`${reason.id}__${index}`"
                    :for="`reason_${reason.id}`"
                    :style="reasonOptionStyle(selectedReason === reason.id)"
                >
                    <input
                        type="radio"
                        :checked="selectedReason === reason.id"
                        :id="`reason_${reason.id}`"
                        name="reason_id"
                        :value="reason.id"
                        :style="srOnly"
                        @change="$emit('change', $event)"
                    />
                    <span :style="reasonRadioDotStyle(selectedReason === reason.id)">
                        <span v-if="selectedReason === reason.id" :style="reasonRadioInnerStyle" />
                    </span>
                    <span :style="reasonOptionLabelStyle">{{ reason.name }}</span>
                </label>
            </div>
        </CCard>
    </div>
</template>

<script>
import CCard from "../c-design/CCard.vue";
import {
    C_INK,
    C_MUTED,
    C_HAIR,
    FONT_DISPLAY,
    FONT_BODY,
} from "../c-design/tokens";

/**
 * Stage 6 of the wizard redesign. The narrowest of the four no-path
 * screens — no textarea, no month accent. Just a reason picker; emits
 * `change` on radio toggle. `selectedReason` drives :checked state.
 */
export default {
    name: "AmountDiffReasonScreen",
    components: { CCard },
    props: {
        selectedReason: { default: null },
        reasons: { type: Array, default: () => [] },
    },
    computed: {
        cardStyle() {
            return { padding: '32px 36px' };
        },
        eyebrowStyle() {
            return {
                fontSize: '12px',
                color: C_MUTED,
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                fontWeight: 600,
                marginBottom: '6px',
            };
        },
        titleStyle() {
            return {
                margin: 0,
                fontFamily: FONT_DISPLAY,
                fontSize: '24px',
                fontWeight: 700,
                letterSpacing: '-0.5px',
                lineHeight: 1.2,
                color: C_INK,
            };
        },
        leadStyle() {
            return {
                margin: '8px 0 22px',
                fontSize: '14px',
                color: C_MUTED,
                lineHeight: 1.55,
            };
        },
        reasonGridStyle() {
            return {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '10px',
            };
        },
        reasonRadioInnerStyle() {
            return {
                width: '8px', height: '8px', borderRadius: '50%',
                background: '#fff', display: 'inline-block',
            };
        },
        reasonOptionLabelStyle() {
            return { fontSize: '14px', fontWeight: 600, color: 'inherit' };
        },
        srOnly() {
            return {
                position: 'absolute', width: '1px', height: '1px',
                margin: '-1px', overflow: 'hidden',
                clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap', border: '0',
            };
        },
    },
    methods: {
        reasonOptionStyle(selected) {
            return {
                textAlign: 'left', padding: '14px 16px',
                background: selected ? C_INK : '#fff',
                color: selected ? '#fff' : C_INK,
                border: `1.5px solid ${selected ? C_INK : C_HAIR}`,
                borderRadius: '12px', fontFamily: FONT_BODY,
                cursor: 'pointer', display: 'flex',
                alignItems: 'center', gap: '12px', position: 'relative',
            };
        },
        reasonRadioDotStyle(selected) {
            return {
                width: '18px', height: '18px', borderRadius: '50%',
                border: `1.5px solid ${selected ? '#fff' : C_HAIR}`,
                display: 'inline-flex', alignItems: 'center',
                justifyContent: 'center', flexShrink: 0,
            };
        },
    },
};
</script>
